module.exports = __webpack_public_path__ + "static/media/T6.5e65e05e.jpg";